import { __assign } from "tslib";
import { ATDealersLinks, ATGroupLinks } from '../footer-shared-links';
export var FooterMotorhomesLinks = function () {
    return [
        __assign({}, ATGroupLinks),
        {
            rowHeading: 'Services',
            subNav: [
                {
                    url: '/motorhomes/finance',
                    displayText: 'Motorhome finance',
                    routerLink: false,
                },
                {
                    url: '/motorhomes/vehicle-check',
                    displayText: 'Vehicle check',
                    routerLink: false,
                },
            ],
        },
        {
            rowHeading: 'Private customers',
            subNav: [
                {
                    url: '/motorhomes/sell',
                    displayText: 'Sell my motorhome',
                    routerLink: false,
                },
                {
                    url: '/motorhomes/sell-my-motorhome/advertising-prices',
                    displayText: 'Advertising costs',
                    routerLink: false,
                },
                {
                    url: '/safety_and_security_centre',
                    displayText: 'Buying & selling safely online',
                    routerLink: false,
                },
                {
                    url: '/terms-and-conditions/advertising',
                    displayText: 'Terms & conditions',
                    routerLink: false,
                },
            ],
        },
        {
            rowHeading: 'Quick search',
            subNav: [
                {
                    url: '/motorhomes/used-motorhomes/browse-all-makes',
                    displayText: 'All motorhomes makes',
                    routerLink: false,
                },
                {
                    url: '/motorhomes/new-motorhomes',
                    displayText: 'New Motorhomes',
                    routerLink: false,
                },
                {
                    url: '/motorhomes/content',
                    displayText: 'Motorhome reviews',
                    routerLink: false,
                },
                {
                    url: '/motorhomes/motorhome-dealers',
                    displayText: 'Motorhome dealers',
                    routerLink: false,
                },
            ],
        },
        __assign({}, ATDealersLinks),
    ];
};
export default FooterMotorhomesLinks;
